export function isQueryParamPresent(queryParam) {
  var regex = new RegExp("[?&]" + queryParam + "([=&]|$)", 'i');
  return regex.test(window.location.search);
}